export default __webpack_public_path__ + "static/RSP-symbol-color-03aa879597fb981b306fb25449ac833e.png";